// Service d'envoi d'email automatique en arrière-plan
// Utilise Firebase Cloud Functions pour envoyer les emails

import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../config/firebase';

/**
 * Envoyer un email de réservation automatiquement en arrière-plan
 * SANS ouvrir le client email - envoi direct et silencieux via Firebase Functions
 * @param {Object} reservationData - Données de la réservation
 * @returns {Promise} Promesse résolue ou rejetée
 */
export const sendReservationEmail = async (reservationData) => {
  try {
    // Utiliser Firebase Cloud Functions pour l'envoi automatique
    const functions = getFunctions(app);
    const sendEmail = httpsCallable(functions, 'sendReservationEmail');
    
    const result = await sendEmail({
      name: reservationData.name || '',
      emailOrPhone: reservationData.emailOrPhone || '',
      date: reservationData.date,
      time: reservationData.time,
      persons: reservationData.persons || '2',
      note: reservationData.note || ''
    });

    console.log('✅ Email envoyé automatiquement en arrière-plan via Firebase Functions:', result.data);
    return { 
      success: true, 
      method: 'firebase-functions', 
      result: result.data 
    };
  } catch (error) {
    console.error('❌ Erreur lors de l\'envoi de l\'email via Firebase Functions:', error);
    
    // Si la fonction n'est pas encore déployée, afficher un message clair
    if (error.code === 'functions/not-found' || error.message?.includes('NOT_FOUND')) {
      throw new Error(
        'La fonction Firebase n\'est pas encore déployée. ' +
        'Exécutez: firebase deploy --only functions'
      );
    }
    
    throw error;
  }
};
